import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const LoadingDescColumn = ColumnTree.defineNode('loading-desc', () => ({
  title: (
    <FormattedMessage
      id="marketplace-table-heading-loadingconfig"
      defaultMessage="Loading"
    />
  ),
  key: 'loading',
  className: 'col-loading',
  render: (text, record) => (
    <div className="td-content">{record.loading.desc}</div>
  ),
}));
